module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAAAXNSR0IB2cksfwAAADNQTFRFAAAAQK/6Qq/6Qq/6Qq/6Q6/7Qq/6QK/3Qq/6Qq/6Qq/5Q676Qq/7Qa75Qq/6QK//RK/7mCjt1gAAABF0Uk5TADDf73Cw/yDA8IBff0+QEEAvT62oAAAAQElEQVR4nEXKWw7AIAwDQSehTqHlcf/TFhEq9mskGwBELSG6SHrwPpTMsg/+vDXU5k6VqcSVOboF2TC2qCg/+QFImwG2m+G65QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-user-alt.png
// module id = 780
// module chunks = 1